import React from 'react';
import { BrowserRouter as Router, Route } from "react-router-dom";

import Login from './Containers/Login/Index'
import Wazzup from './Containers/Wazzup/Index'
import Filtered from './Containers/Wazzup/Filtered'
import WazzupChat from './Containers/Wazzup/Chat'
import Chat from './Containers/Chat/Index'
import Messages from './Containers/Chat/Messages'
import Groups from './Containers/Community/Groups/Index'
import Feed from './Containers/Community/Groups/Feed'
import Meetings from './Containers/Community/Meetings/Index'
import MeetingDetail from './Containers/Community/Meetings/Show'


import './scss/main.scss'

function App() {
	return (
		<Router basename="/webapp">
			<Route path="/" exact component={Login} />
			<Route path="/wazzup" exact component={Wazzup} />
			<Route path="/wazzup/filtered/:id" exact component={Filtered} />
			<Route path="/wazzup/chat/:uuid" exact component={WazzupChat} />
			<Route path="/chat" exact component={Chat} />
			<Route path="/messages" exact component={Messages} />
			<Route path="/community/groups" exact component={Groups} />
			<Route path="/community/groups/:uuid" exact component={Feed} />
			<Route path="/community/meetings" exact component={Meetings} />
			<Route path="/community/meetings/:id" exact component={MeetingDetail} />
		</Router>
	)
}

export default App;
